module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "basic-info"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('accountOverview')))]), _vm._v(" "), _c('div', {
    staticClass: "content-box",
    attrs: {
      "id": "account-container"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "text-left little-title"
  }, [_vm._v(_vm._s(_vm.$t('me')))]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "user-info-name"
  }, [_vm._v(_vm._s(_vm.user.nickname))]), _vm._v(" "), _c('p', {
    class: ['user-info-type', {
      'expired': _vm.userDataExpired
    }]
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!!_vm.roleIcon),
      expression: "!!roleIcon"
    }],
    attrs: {
      "src": '/static/img/dashboard/' + _vm.roleIcon,
      "alt": "You are "
    }
  }), _vm._v(_vm._s(_vm.role) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "main-num"
  }, [_c('p', [_c('span', {
    class: {
      "expire-in": _vm.showExipreIn
    }
  }, [_vm._v(_vm._s(_vm.getExpiredTime()))]), _c('br'), _vm._v(_vm._s(_vm.showExipreIn ? _vm.$t('expireIn') : _vm.user.value_of_expire_in <= 1 ? _vm.$tc(_vm.user.unit_of_expire_in, 1) : _vm.$tc(_vm.user.unit_of_expire_in, 2)) + "\n          "), _c('em', {
    staticClass: "divider"
  })]), _vm._v(" "), _c('p', [_c('span', [_vm._v(_vm._s(_vm.user.max_device_count))]), _c('br'), _vm._v(_vm._s(_vm.user.max_device_count <= 1 ? _vm.$tc('devices', 1) : _vm.$tc('devices', 2)))])])])]), _vm._v(" "), (_vm.mediaType !== 'phone') ? _c('div', {
    staticClass: "content-box",
    attrs: {
      "id": "service-container"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "little-title"
  }, [_vm._v(_vm._s(_vm.$t('serviceTime')))]), _vm._v(" "), _c('div', {
    staticClass: "main-num"
  }, [_c('p', [_c('span', {
    class: {
      "expire-in": _vm.showExipreIn
    }
  }, [_vm._v(_vm._s(_vm.getExpiredTime()))]), _c('br'), _vm._v(_vm._s(_vm.showExipreIn ? _vm.$t('expireIn') : _vm.user.value_of_expire_in <= 1 ? _vm.$tc(_vm.user.unit_of_expire_in, 1) : _vm.$tc(_vm.user.unit_of_expire_in, 2)))]), _vm._v(" "), _c('p', [_c('span', [_vm._v(_vm._s(_vm.user.max_device_count))]), _c('br'), _vm._v(_vm._s(_vm.user.max_device_count <= 1 ? _vm.$tc('devices', 1) : _vm.$tc('devices', 2)))])]), _vm._v(" "), _c('p', {
    staticClass: "describe"
  }, [_vm._v(_vm._s(_vm.$t('serviceInstructions')))])])]) : _vm._e(), _vm._v(" "), (_vm.mediaType !== 'phone') ? _c('div', {
    staticClass: "content-box",
    attrs: {
      "id": "rewards-container"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "little-title"
  }, [_vm._v(_vm._s(_vm.$t('rewards')))]), _vm._v(" "), _c('div', {
    staticClass: "main-num"
  }, [_c('p', {
    staticClass: "first-num"
  }, [_c('span', {
    staticClass: "stress"
  }, [_vm._v(_vm._s(_vm.user.invitation_count))]), _c('br'), _vm._v(_vm._s(_vm.$tc(_vm.user.invitation_count <= 1 ? _vm.$tc('friends', 1) : _vm.$tc('friends', 2), _vm.user.invitation_count)))]), _vm._v(" "), _c('p', {
    staticClass: "second-num"
  }, [_c('span', {
    staticClass: "stress"
  }, [_vm._v(_vm._s(_vm.user.award_days))]), _c('br'), _vm._v(_vm._s(_vm.$tc(_vm.user.award_days <= 1 ? _vm.$tc('days', 1) : _vm.$tc('days', 2), _vm.user.award_days)))])]), _vm._v(" "), _c('div', {
    staticClass: "describe"
  }, [_vm._v(_vm._s(_vm.$t('rewardsDescribe')) + " "), _c('router-link', {
    staticClass: "reward-rules",
    attrs: {
      "to": "/reward-rules"
    }
  }, [_vm._v(_vm._s(_vm.$t('rewardRules')))])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.mediaType !== 'phone') ? _c('div', {
    staticClass: "content-box",
    attrs: {
      "id": "invitation-container"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "little-title"
  }, [_vm._v(_vm._s(_vm.$t('myInvitationCode')))]), _vm._v(" "), _c('p', {
    staticClass: "invitation-code"
  }, [_vm._v(_vm._s(_vm.$t('invitationCode'))), _c('span', [_vm._v(_vm._s(_vm.user.invitation_code))])]), _vm._v(" "), _c('div', {
    staticClass: "invite-url-component"
  }, [_c('invite-url', {
    attrs: {
      "invitation-code": _vm.user.invitation_code
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "clearfix"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "avatar"
  }, [_c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": "/static/img/dashboard/avatar_2x.png",
      "alt": "临时头像"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-02b93c5d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/dashboard/accountInfo/Index.vue
// module id = 1253
// module chunks = 1